import { nanoid } from 'nanoid';

export enum AttachmentType {
    SINGLE_PDF = 'single_pdf',
    TABLE_PDF = 'chart_pdf',
    TABLE_XLS = 'chart_xlsx',
    SYNOPSIS_CSV = 'report_csv',
    SYNOPSIS_XLS = 'report_xlsx',
}

export enum EmailInterval {
    OFF = 'OFF',
    EVERY_NEW_REPLY = 'EVERY_NEW_REPLY',
    EVERY_DAY = 'EVERY_DAY',
    EVERY_THREE_DAY = 'EVERY_THREE_DAY',
    EVERY_WEEK_DAY = 'EVERY_WEEK_DAY',
    EVERY_FOURTEEN_DAY = 'EVERY_FOURTEEN_DAY',
    EVERY_MONTH = 'EVERY_MONTH',
}

export interface Email {
    id: string;
    email: string;
    interval: EmailInterval;
    reportType: Array<AttachmentType>;
    logic: Array<Logic>;
}

export interface Logic {
    id: string;
    questionId: number;
    type: number;
    selected: number;
    conditions: Array<any>;
    emailId: string;
}

export const initialEmail: Readonly<Email> = {
    get id() {
        return nanoid();
    },
    email: '',
    interval: EmailInterval.OFF,
    reportType: [],
    logic: [],
};

export interface Notify {
    emails: Array<Email>;
}

export const initialNotify: Readonly<Notify> = {
    emails: [],
};
